import {
  API_ENDPOINT,
  useClientApiV5AuthSignupCreateMutation,
} from '../../resources/@types/accountSchema';

interface UseClientV5AuthSignupMutation {
  options?: Parameters<typeof useClientApiV5AuthSignupCreateMutation>[0]['options'];
}

/**
 * 휴대폰 인증 + 매체별 마케팅 동의 가입(기능플래그 263 ON). OFF 경로는 useAuthSignupCreateMutation(v4)을 쓴다.
 */
export function useAuthSignupV5CreateMutation({ options }: UseClientV5AuthSignupMutation) {
  return useClientApiV5AuthSignupCreateMutation({
    url: API_ENDPOINT.CLIENT_V5_AUTH_SIGNUP,
    options,
  });
}
